import {
  DeductionSourceParamValues,
  MixpanelExtraParams,
  MixpanelExtraParamsKeys,
  Modules,
} from 'rdx/analytics/types';

export function getMixpanelExtraParams(moduleName: string, search: string): MixpanelExtraParams {
  const searchParams = new URLSearchParams(search);
  const extraParams: MixpanelExtraParams = {};
  if (searchParams.has(MixpanelExtraParamsKeys.SOURCE)) {
    let source = null;
    switch (moduleName) {
      case Modules.DEDUCTIONS: {
        const deductionSource = searchParams.get(MixpanelExtraParamsKeys.SOURCE);
        if (deductionSource && DeductionSourceParamValues.includes(deductionSource)) {
          source = deductionSource;
        }
        break;
      }
      default:
        break;
    }
    if (source) {
      extraParams[MixpanelExtraParamsKeys.SOURCE] = source;
    }
  }
  return extraParams;
}
